import clsx from 'clsx'

const PRIVACY_POLICY_URL =
  'https://inflectionmedicine.com/documents/inflection-medicine-privacy-policy-jan2026.pdf'
const TERMS_URL = 'https://inflectionmedicine.com/documents/inflection-website-terms-and-conditions.pdf'
const CONTACT_EMAIL = 'mailto:support@inflectionmedicine.com'

type ApplicationFooterProps = {
  className?: string
}

export function ApplicationFooter({ className }: ApplicationFooterProps) {
  const year = new Date().getFullYear()

  return (
    <footer
      className={clsx('w-full px-2 py-8 sm:px-4', className)}
      aria-label="Site footer"
    >
      <div className="mx-auto flex w-full max-w-[1200px] flex-wrap items-center justify-center gap-6">
        <p className="text-center text-sm font-normal leading-5 text-text-body dark:text-gray-400">
          © {year} Inflection Medicine. All rights reserved.
        </p>
        <span
          className="hidden h-1.5 w-1.5 shrink-0 rounded-full bg-background-quaternary dark:bg-gray-800 sm:block"
          aria-hidden
        />
        <nav
          className="flex flex-wrap items-center justify-center gap-6 text-sm font-medium leading-5 text-text-heading dark:text-white"
          aria-label="Legal and contact"
        >
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline hover:text-brand-600 dark:hover:text-brand-400"
          >
            Privacy Policy
          </a>
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline hover:text-brand-600 dark:hover:text-brand-400"
          >
            Terms &amp; Conditions
          </a>
          <a
            href={CONTACT_EMAIL}
            className="no-underline hover:text-brand-600 dark:hover:text-brand-400"
          >
            Contact Us
          </a>
        </nav>
      </div>
    </footer>
  )
}
